import iconBlueTone from '@assets/img/logo_icoon_bluetone.svg';
import type { ApiActivityPlan } from '../../../types/llinkidApiTypes';
import type { HrefObject } from '../../../types/genericApiTypes';
import type { ActivityWithDates } from '@store/calendar/calendarTypes';
import type { VmClass } from '@store/userAndSchool/userAndSchoolTypes';
import CalendarPrintActivity from './CalendarPrintActivity';
import './calendarPrint.scss';

type PrintCalendar = Omit<ApiActivityPlan, 'class' | 'creators'> & {
  class: VmClass;
  creators: Array<HrefObject & { $$displayName?: string }>;
  activities: ActivityWithDates[];
  calendarRange: string;
};

interface CalendarPrintItemProps {
  calendar: PrintCalendar;
}

const CalendarPrintItem = ({ calendar }: CalendarPrintItemProps) => {
  const { title, creators, class: classes, activities, calendarRange } = calendar;
  const teachersName = creators.map((t) => t.$$displayName).filter(Boolean).join(', ');

  return (
    <div className="calendar-print draft-sheet">
      <header className="print-header">
        <img className="logo" src={iconBlueTone} alt="" />
        <div className="title-wrapper">
          <h1 className="title">{title}</h1>
          <span className="teachers">
            <b>Krabbelblaadje</b> voor {teachersName}
          </span>
        </div>
        <div className="classes">
          <div className="calendar-range">{calendarRange}</div>
          <div key={classes.key} className="class-button">
            {classes.$$displayName}
          </div>
        </div>
      </header>
      <main className="print-activities">
        {activities.map((activity) => (
          <CalendarPrintActivity key={activity.key} activity={activity} />
        ))}
      </main>
    </div>
  );
};

export default CalendarPrintItem;
